<template>
  <div class="component-page3">
    <img src="./page3.jpg" style="width: 100%" alt="">
  </div>
</template>

<script>
export default {
  name: "page3",
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  filters: {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.component-page3 {

}
</style>
<style lang="scss">
.component-page3_body { //dialog使用 customClass="xxx_body"

}
</style>
